import { useState, useEffect } from 'react';
import { C } from '../../hooks/useUsers.js';
import { ROLE_COLORS, ROLE_LABELS, ROLE_HIERARCHY } from '../../models/User.js';
import { userController } from '../../controllers/userController.js';
// ── User Reports Page ────────────────────────────────────────────────────────
export function UserReportsPage() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    userController.getStats().then(res => { if (res.success) setStats(res.data); });
  }, []);

  if (!stats) return <div style={{ padding: '40px', textAlign: 'center', color: '#94a3b8' }}>Loading…</div>;

  const roles = Object.entries(stats.byRole).filter(([, v]) => v > 0);
  const maxCount = Math.max(...roles.map(([, v]) => v));

  return (
    <div style={C.page}>
      <div style={C.header}>
        <h1 style={{ ...C.title, borderLeft: '4px solid #7c3aed', paddingLeft: '12px' }}>User Reports</h1>
      </div>

      {/* Summary cards */}
      <div style={C.statsBar}>
        {[
          { label:'Total Users',  value: stats.total,      color:'#3b82f6' },
          { label:'Active',       value: stats.active,     color:'#10b981' },
          { label:'Blocked',      value: stats.blocked,    color:'#ef4444' },
          { label:'Unverified',   value: stats.unverified, color:'#f59e0b' },
          { label:'New Today',    value: stats.newToday,   color:'#8b5cf6' },
        ].map(s => (
          <div key={s.label} style={{ ...C.statCard, borderLeftColor: s.color }}>
            <div style={C.statLabel}>{s.label}</div>
            <div style={{ ...C.statVal, color: s.color }}>{s.value}</div>
          </div>
        ))}
      </div>

      {/* Bar chart by role */}
      <div style={C.card}>
        <div style={{ padding: '18px 24px', borderBottom: '1px solid #f1f5f9', fontWeight: '600', fontSize: '14px' }}>Users by Role</div>
        <div style={{ padding: '24px' }}>
          {roles.map(([role, count]) => (
            <div key={role} style={{ marginBottom: '16px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                <span style={{ fontSize: '13px', fontWeight: '500', color: ROLE_COLORS[role] }}>{ROLE_LABELS[role] || role}</span>
                <span style={{ fontSize: '13px', fontWeight: '700', color: '#0f172a' }}>{count}</span>
              </div>
              <div style={{ height: '8px', backgroundColor: '#f1f5f9', borderRadius: '4px', overflow: 'hidden' }}>
                <div style={{
                  height: '100%', borderRadius: '4px',
                  width: `${(count / maxCount) * 100}%`,
                  backgroundColor: ROLE_COLORS[role],
                  transition: 'width .5s ease',
                }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
export default UserReportsPage;